import { getLinkIconPath, getLinkTitle, Link, LinkType } from "model/Links";
import { IconContainer, IconImage } from "./styles";

interface Props {
  link: Link;
}

export const IconLink = ({ link }: Props) => {
  return (
    <a title={getLinkTitle(link)} href={link.url} target="_blank">
      <IconContainer type={link.type}>{getIcon(link.type)}</IconContainer>
    </a>
  );
};

const getIcon = (type: LinkType | undefined) => {
  const link = !!type ? getLinkIconPath(type) : undefined;
  if (!type) {
    return <span>O</span>;
  }

  return <IconImage src={link} />;
};
